import {css} from "@panda/css";

import {BrandSecretClientIcon} from "@pg-design/icons-module";

export const SemanticSearchClientIcon = () => {
    return (
        <div className={iconWrapper}>
            <BrandSecretClientIcon className={iconSize} />
        </div>
    );
};

const iconWrapper = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    mb: 4,

    "@container aiAdvisor (max-height: 720px)": {
        mb: 2
    },

    "@container aiAdvisor (max-height: 560px)": {
        mb: 1
    },

    "@container aiAdvisor (max-height: 420px)": {
        mb: 0.5
    }
});

const iconSize = css({
    width: "21.4rem",
    height: "20.8rem",

    md: {
        width: "26.8rem",
        height: "26rem"
    },

    // The sidebar panel is a size container. Cap the mascot so the welcome state still fits
    // when the panel is shorter than the viewport (top of the listing on a laptop).
    "@container aiAdvisor (max-height: 900px)": {
        width: "auto",
        maxWidth: "100%",
        height: "min(26rem, 30cqh)"
    },

    "@container aiAdvisor (max-height: 560px)": {
        height: "min(16rem, 24cqh)"
    },

    "@container aiAdvisor (max-height: 420px)": {
        height: "4.8rem"
    }
});
import {css} from "@panda/css";

import {BrandSecretClientIcon} from "@pg-design/icons-module";

export const SemanticSearchClientIcon = () => {
    return (
        <div className={iconWrapper}>
            <BrandSecretClientIcon className={iconSize} />
        </div>
    );
};

const iconWrapper = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    mb: 4,

    "@container aiAdvisor (max-height: 720px)": {
        mb: 2
    },

    "@container aiAdvisor (max-height: 560px)": {
        mb: 1
    },

    "@container aiAdvisor (max-height: 420px)": {
        mb: 0.5
    }
});

const iconSize = css({
    width: "21.4rem",
    height: "20.8rem",

    md: {
        width: "26.8rem",
        height: "26rem"
    },

    // The sidebar panel is a size container. Cap the mascot so the welcome state still fits
    // when the panel is shorter than the viewport (top of the listing on a laptop).
    "@container aiAdvisor (max-height: 900px)": {
        width: "auto",
        maxWidth: "100%",
        height: "min(26rem, 30cqh)"
    },

    "@container aiAdvisor (max-height: 560px)": {
        height: "min(16rem, 24cqh)"
    },

    "@container aiAdvisor (max-height: 420px)": {
        height: "4.8rem"
    }
});
